import React, { createContext, useContext, useState, useCallback } from 'react';

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([
    // 标准通知 (System)
    {
      id: '1',
      title: 'Welcome to Plypto!',
      message: 'Start predicting crypto prices and earn rewards. Your journey into the future of crypto predictions begins now!',
      type: 'info',
      category: 'system',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 5) // 5分钟前
    },
    {
      id: '2',
      title: 'Wallet Connected Successfully',
      message: 'Your wallet has been successfully connected to Plypto. You can now start making predictions and earning rewards.',
      type: 'success',
      category: 'system',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 15) // 15分钟前
    },
    {
      id: '3',
      title: 'Bitcoin Price Alert',
      message: 'Bitcoin (BTC) has increased by 5.2% in the last hour. Current price: $67,890. Your prediction is performing well!',
      type: 'success',
      category: 'market',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 25) // 25分钟前
    },
    {
      id: '4',
      title: 'Ethereum Prediction Won!',
      message: 'Congratulations! Your ETH prediction was correct. You earned 50 PLYP tokens. Keep up the great predictions!',
      type: 'success',
      category: 'prediction',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 45) // 45分钟前
    },
    {
      id: '5',
      title: 'Market Volatility Warning',
      message: 'High volatility detected in the crypto market. Consider adjusting your prediction strategies accordingly.',
      type: 'warning',
      category: 'market',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 60) // 1小时前
    },
    {
      id: '6',
      title: 'New Feature: AI Predictions',
      message: 'We\'ve launched AI-powered prediction insights! Check out the new AI analysis feature in your dashboard.',
      type: 'info',
      category: 'system',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 90) // 1.5小时前
    },
    {
      id: '7',
      title: 'Prediction Expired',
      message: 'Your BTC 1-hour prediction has expired. The result: Bitcoin went up by 2.1%. Unfortunately, you predicted down.',
      type: 'error',
      category: 'prediction',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 120) // 2小时前
    },
    {
      id: '8',
      title: 'Weekly Rewards Available',
      message: 'Your weekly prediction rewards are ready to claim! You earned 125 PLYP tokens this week.',
      type: 'success',
      category: 'activity',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 180) // 3小时前
    },
    {
      id: '9',
      title: 'System Maintenance',
      message: 'Scheduled maintenance will occur tonight from 2:00 AM to 4:00 AM UTC. Predictions will be temporarily unavailable.',
      type: 'warning',
      category: 'system',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 240) // 4小时前
    },
    {
      id: '10',
      title: 'Solana Price Surge',
      message: 'SOL has surged 15% in the past 2 hours! Check if you have any active predictions on Solana.',
      type: 'info',
      category: 'market',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 300) // 5小时前
    },
    {
      id: '11',
      title: 'Account Security Update',
      message: 'We\'ve enhanced our security measures. Your account is now more secure with improved wallet integration.',
      type: 'info',
      category: 'system',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24) // 1天前
    },
    {
      id: '12',
      title: 'Referral Bonus Earned',
      message: 'You earned 25 PLYP tokens for referring a friend! Your friend has successfully made their first prediction.',
      type: 'success',
      category: 'activity',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2) // 2天前
    },
    {
      id: '13',
      title: 'DeFi Market Analysis',
      message: 'New DeFi tokens are showing strong momentum. Consider exploring predictions in the DeFi category.',
      type: 'info',
      category: 'market',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 3) // 3天前
    },
    {
      id: '14',
      title: 'Prediction Streak Bonus',
      message: 'Amazing! You\'ve maintained a 7-day winning streak. Bonus multiplier activated for your next prediction!',
      type: 'success',
      category: 'prediction',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 4) // 4天前
    },
    {
      id: '15',
      title: 'Network Congestion Alert',
      message: 'Ethereum network is experiencing high congestion. Transaction fees may be higher than usual.',
      type: 'warning',
      category: 'system',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 5) // 5天前
    },
    // 添加更多分类示例
    {
      id: '16',
      title: 'New Listing: PEPE Token',
      message: 'PEPE token is now available for predictions! Start making predictions on this trending meme coin.',
      type: 'info',
      category: 'market',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 30) // 30分钟前
    },
    {
      id: '17',
      title: 'Double Rewards Weekend!',
      message: 'This weekend only: Earn 2x PLYP tokens for all correct predictions! Don\'t miss out!',
      type: 'success',
      category: 'activity',
      isRead: false,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2) // 2小时前
    },
    {
      id: '18',
      title: 'Prediction Result: DOGE',
      message: 'Your DOGE 4-hour prediction result is in: DOGE went down by 3.2%. You predicted correctly and earned 25 PLYP!',
      type: 'success',
      category: 'prediction',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 6) // 6小时前
    },
    {
      id: '19',
      title: 'Flash Sale: Premium Features',
      message: '24-hour flash sale! Get premium prediction analytics for 50% off. Limited time offer!',
      type: 'info',
      category: 'activity',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12) // 12小时前
    },
    {
      id: '20',
      title: 'Market Alert: BTC Resistance',
      message: 'Bitcoin is approaching key resistance at $70,000. High volatility expected in the next few hours.',
      type: 'warning',
      category: 'market',
      isRead: true,
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 18) // 18小时前
    }
  ]);

  // 获取未读消息数量
  const unreadCount = notifications.filter(n => !n.isRead).length;

  // 添加新通知
  const addNotification = useCallback((notification) => {
    const newNotification = {
      id: Date.now().toString(),
      isRead: false,
      timestamp: new Date(),
      category: 'system', // 默认分类
      ...notification
    };
    setNotifications(prev => [newNotification, ...prev]);
  }, []);

  // 标记通知为已读
  const markAsRead = useCallback((notificationId) => {
    setNotifications(prev => 
      prev.map(notification => 
        notification.id === notificationId 
          ? { ...notification, isRead: true }
          : notification
      )
    );
  }, []);

  // 标记所有通知为已读
  const markAllAsRead = useCallback(() => {
    setNotifications(prev => 
      prev.map(notification => ({ ...notification, isRead: true }))
    );
  }, []);

  // 删除通知
  const removeNotification = useCallback((notificationId) => {
    setNotifications(prev => 
      prev.filter(notification => notification.id !== notificationId)
    );
  }, []);

  // 清空所有通知
  const clearAllNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  const value = {
    notifications,
    unreadCount,
    addNotification,
    markAsRead,
    markAllAsRead,
    removeNotification,
    clearAllNotifications
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
}
